<template>
<div >
    <div class="detailsTitle" >
       <h4>提货单详情</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="addressBox" style="margin-bottom:20px;">
       <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
    </h4>
    <div >
      <el-table :data="sVirtualGoods"    bordersize="mini"  class="table"  style="width: 100%" center  border>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="organizationName" width="240" label="所在仓库"></el-table-column>
          <el-table-column property="steelMillName" width="200" label="产地"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="model" width="150" label="材质"></el-table-column>
          <!-- <el-table-column property="root" width="120" label="单件支数"></el-table-column>
          <el-table-column property="length" width="120" label="长度(m)"></el-table-column> -->
          <el-table-column prop="plan"  min-width="180"  label="提货量(吨/件)">
            <template scope="scope">
              <div>
                {{scope.row.planWeight}} / {{scope.row.planNum}}
              </div>
            </template>
          </el-table-column>
      </el-table>
      <div class="searchBtnBox" style="display:flex;">
            <p style="font-size: 14px;">合计重量:<span class="red">{{billData.planWeight}}</span>吨</p>
            <p style="font-size: 14px;margin-left:20px;">合计件数:<span class="red">{{billData.planNum}}</span>件</p>
       </div>
    </div>
    </div>
    <div class="addressBox"  style="margin-bottom:20px;">
    <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>提货单记录</span>
    </h4>
    <div>
       <el-form :inline="true" enctype="multipart/form-data" class="demo-form-inline inpBox" label-width="110px" size="mini">
          <div>
            <el-form-item label="创建时间:" prop="createTime">
              <el-date-picker v-model="billData.createTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                  placeholder=""
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="创建人:" prop="createUserName">
              <span>{{billData.createUserName}}</span>
            </el-form-item>
            <div v-if="billData.remark">
               <el-form-item label="备注信息:" prop="remark">
                <div style="width:70vw">{{billData.remark}}</div>
              </el-form-item>
            </div>
          </div>
          <div>
             <el-form-item label="完成时间:" prop="completeTime" v-if="billData.status==2">
              <el-date-picker v-model="billData.completeTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                  placeholder=""
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="作废时间:" prop="completeTime" v-if="billData.status==3">
              <el-date-picker v-model="billData.completeTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                  placeholder=""
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="作废原因:" prop="abandonedReason">
              <span>{{billData.abandonedReason}}</span>
            </el-form-item>
          </div>
       </el-form>
    </div>
    </div>
     <div class="addressBox" >
       <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>提货人车</span>
    </h4>
    <div >
      <el-table :data="billCarriageInfos"    bordersize="mini"  class="table"  style="width: 100%" center border >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="vhcNo"  label="提货车号"></el-table-column>
          <el-table-column property="driverName"  label="司机姓名"></el-table-column>
          <el-table-column property="driverIdentityNo"   label="身份证号"></el-table-column>
          <el-table-column property="driverMobile"   label="联系电话"></el-table-column>
      </el-table>
    </div>
    </div>
    <div class="addressBox" v-if="flowAuditLogs.length>0" style="margin-top:20px;">
      <h4 class="title" style="margin-bottom:10px;">
        <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审批记录</span>
      </h4>
      <div>
          <el-table :data="flowAuditLogs"    bordersize="mini"  class="table"  style="width: 100%" center border >
            <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column property="checkUserName" width="160" label="审批人"></el-table-column>
            <el-table-column property="checkTime" :formatter="dateTimeFormat" width="200" label="审批时间"></el-table-column>
            <el-table-column property="status"  width="130" label="审批状态" >
              <template scope="scope">
                {{[ "待审批","通过", "驳回" ][scope.row.status]}}
              </template>
            </el-table-column>
            <el-table-column property="checkReason" min-width="260" label="审批意见"></el-table-column>
        </el-table>
      </div>
    </div>
</div>
</template>

<script>
import { dateTimeFormat } from '@/utils/util'
import { SVBdetail } from '@/api/soc-stock-cosco'
export default {
  data () {
    let id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      id: id,
      billCarriageInfos: [],
      sVirtualGoods: [],
      flowAuditLogs: [],
      billData: {}
    }
  },
  created () {
    SVBdetail({ id: this.id }).then(res => {
      this.billCarriageInfos = res.sVirtualBillExt.billCarriageInfos
      this.sVirtualGoods = res.sVirtualBillExt.sVirtualGoods
      this.billData = res.sVirtualBillExt
      this.flowAuditLogs = res.flowAuditLogs
    })
  },
  mounted () {
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox  /deep/.el-input__inner{
  border:none;
  padding: 0;
  color:#333;
   font-size: 14px;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form-item--mini.el-form-item{
    margin-bottom: 0px;
}
/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
 /deep/.el-input__suffix, /deep/.el-input__icon{
   display: none;
 }
 .danwei{
   /deep/ .el-input__inner{
         width: 300px;
    overflow: auto;
   }
 }
.box1{
  display: flex;
  padding-left: 20px;
  .item{
    max-width: 48%;
    margin-left: 10px;
    font-size: 14px;
  }
  .box1T{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .box1B{
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right: 20px;
      line-height: 26px;
    }
  }
}
</style>
